import React, { useState, useEffect, useRef, useContext } from "react";
import { useLocation } from "react-router-dom";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { AppContext } from "../../../context/AppContext";
import Loader from "../loader";
import NoDataFound from "../NodataFound";
import addedit from "../../../assets/images/Editac.svg";
import uploadicon from "../../../assets/images/plus_officecaller.svg";
import ApiConfig, { BASE_URL_CHATADMIN } from "../../../api/ApiConfig";
import { ToastMsg } from "../../TostMsg";
import { multipartPostCallWithErrorResponse, simpleGetCallWithErrorResponse } from "../../../api/ApiServices";




const Topics = () => {
  const ref = useRef(null);
  const { sidebar, selectedDomainId,HeaderDynamic } = useContext(AppContext);
  const location = useLocation();
  const subtopic = location.pathname.split("/").pop(); // e.g. "DashboardMap"

  const [isLoading, setIsLoading] = useState(true);
  const [topics, setTopics] = useState([]);
  const [editIntent, setEditIntent] = useState("");
  const [editModule, setEditModule] = useState({
    image_url: "",
    topic_display_name: "",
    topic:""
  });

  const [isIlstrVies, setIsIlstrView] = useState(false);
  const [ilstrViewUrl, setIlstrViewUrl] = useState("");

  const istrPreviewClose = () => {
    setIlstrViewUrl("");
    setIsIlstrView(false);
  };

  const getTopics = () => {
    setIsLoading(true);
    simpleGetCallWithErrorResponse(
      ApiConfig.GET_TOPICS + `sub_module=${subtopic}&domain_id=${selectedDomainId}`
    )
      .then((res) => {
        if (res?.json?.success) {
          setTopics(res?.json?.data || []);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getTopics();
  }, [selectedDomainId]);

  const handleEditModule = (key, val) => {
    setEditModule((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const handleUploadIcon = () => {
    ref.current.click();
  };

  const handleUpdate = () => {
    if (!editIntent) {
      ToastMsg("error", "Please select a topic to edit");
      return;
    }

    const formdata = new FormData();
    // only update these 2 fields
    formdata.append("image_url", editModule.image_url || "");
    formdata.append("topic_display_name", editModule.topic_display_name || "");
    // send intent instead of ID
    formdata.append("intent", editIntent);
    formdata.append("topic", editModule.topic);
    formdata.append("domain_id", selectedDomainId);

    setIsLoading(true);
    multipartPostCallWithErrorResponse(ApiConfig.UPDATE_SAB_TOPIC, formdata)
      .then((res) => {
        setIsLoading(false);
        if (res?.json?.success) {
          ToastMsg("success", res?.json?.message);
          setEditModule({ image_url: "", topic_display_name: "" });
          setEditIntent("");
          getTopics();
        } else {
          ToastMsg("error", res?.json?.message);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        ToastMsg("error", "Something went wrong while updating");
        console.error(err);
      });
  };

  return (
    <div className={sidebar ? "taskMain" : "cx-active taskMain"} id="cx-main">
      <div>
        <div className="role-content">
          <div className="sub-header-role d-flex justify-content-between">
            <h6 className="mt-2">{HeaderDynamic}/{subtopic}</h6>
          </div>

          <div className="table-wrapper table-wrapper-2" style={{ height: "600px" }}>
            {isLoading ? (
              <Loader />
            ) : topics?.length ? (
              <table style={{ marginBottom: "20px" }}>
                <thead>
                  <tr className="firstTabelRow">
                    <th>Sr. No</th>
                    <th>Sub Module Name</th>
                    <th>Topic Display Name</th>
                    <th>Image</th>
                    <th>Primary Action</th>
                    <th>Route</th>
                 
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {topics.map((topic, index) => (
                    <tr key={topic.intent} className="table-row-custom">
                      <td>{index + 1}</td>
                      <td>
                         {/* { topic.topic} */}
                           {editIntent === topic.intent ? (
                          <input
                            type="text"
                            className="form-control"
                            value={editModule.topic}
                            onChange={(e) =>
                              handleEditModule("topic", e.target.value)
                            }
                          />
                        ) : (
                          topic.topic
                        )}
                      </td>
                        {/* Editable text field */}
                      <td>
                        {editIntent === topic.intent ? (
                          <input
                            type="text"
                            className="form-control"
                            value={editModule.topic_display_name}
                            onChange={(e) =>
                              handleEditModule("topic_display_name", e.target.value)
                            }
                          />
                        ) : (
                          topic.topic_display_name
                        )}
                      </td>
                      {/* Editable icon field */}
                      <td>
                        {editIntent === topic.intent ? (
                          <>
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 100, hide: 300 }}
                              overlay={(props) => (
                                <Tooltip id="button-tooltip" {...props}>
                                  Change Icon
                                </Tooltip>
                              )}
                            >
                              <img
                               src={
  editIntent === topic.intent
    ? editModule.image_url instanceof File
      ? URL.createObjectURL(editModule.image_url)
      : topic.image_url
      ? topic.image_url
      : uploadicon
    : topic.image_url
    ? BASE_URL_CHATADMIN + topic.image_url
    : uploadicon
}
                                style={{ width: "30px", cursor: "pointer" }}
                                onClick={handleUploadIcon}
                                onError={(e) => (e.target.src = uploadicon)}
                                alt="icon"
                              />
                            </OverlayTrigger>
                            <input
                              type="file"
                              ref={ref}
                              style={{ display: "none" }}
                              accept="image/*"
                              onChange={(e) =>
                                handleEditModule("image_url", e.target.files[0])
                              }
                            />
                          </>
                        ) : (
                          <img
                            src={
                              topic.image_url
                                ? topic.image_url
                                : uploadicon
                            }
                            style={{ width: "30px" }}
                            onError={(e) => (e.target.src = uploadicon)}
                            alt="icon"
                             onClick={() => {

                                  if (!topic.topic) return
                                  setIlstrViewUrl(topic.image_url)
                                  setIsIlstrView(true)

                                }}
                          />
                          
                        )}
                      </td>

                      <td>{topic.pr_action}</td>

                      <td>
                        <a href={topic.route} target="_blank" rel="noreferrer">
                          {topic.route}
                        </a>
                      </td>

                      <td>
                        {editIntent === topic.intent ? (
                          <button className="btn btn-success btn-sm" onClick={handleUpdate}>
                            Update
                          </button>
                        ) : (
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 100, hide: 300 }}
                            overlay={(props) => (
                              <Tooltip id="button-tooltip" {...props}>
                                Edit
                              </Tooltip>
                            )}
                          >
                            <img
                              src={addedit}
                              style={{ cursor: "pointer" }}
                              alt="edit"
                              onClick={() => {
                                setEditIntent(topic.intent);
                                setEditModule({
                                  image_url: topic.image_url,
                                  topic_display_name: topic.topic_display_name,
                                  topic:topic.topic
                                });
                              }}
                            />
                          </OverlayTrigger>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <NoDataFound />
            )}
          </div>
        </div>
      </div>

      {/* Illustration Preview Modal */}
      <Modal
        className="delete-news-modal"
        show={isIlstrVies}
        onHide={istrPreviewClose}
        dialogClassName="modal-100w"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="delete-title">Mind Map Preview</Modal.Title>
        </Modal.Header>
        <div className="lineSeperate"></div>

        <img
          src={ilstrViewUrl}
          alt="preview"
          className="m-4 rounded"
        />
      </Modal>
    </div>
  );
};

export default Topics;
